export default "__VITE_ASSET__b2a1804c__"